import { Injectable } from '@angular/core';
import { DaysPlannerService } from '../services';
import { observable, action, computed } from 'mobx-angular';
import { Storage } from '@ionic/storage-angular';
import { GuidesStore } from './guides.store';
import { tap } from 'rxjs/operators';
import { DaysPlane, DaysPlaneSlide } from '../models';
import { toJS } from 'mobx';
import { ShoppingListStore } from './shopping-list.store';
@Injectable()
export class DaysPlannerStore {
    @observable daysPlanner: DaysPlane = {} as DaysPlane;
    @observable currentDayIndex = 1;

    constructor(
        private daysPlannerService: DaysPlannerService,
        private storage: Storage,
        private guidesStore: GuidesStore,
        private shoppingListStore: ShoppingListStore,
    ) {
        storage.get('dayIndex').then((val) => {
            if (val) {
                this.setCurrentDay(parseFloat(val));
            }
        });
    }

    @computed
    get planeSlides(): any[] {
        const slides: DaysPlaneSlide[] = [];
        const introGuides = this.daysPlanner.introGuides.map( id => {
            return this.daysPlanner.guides[id];
        });

        const endingGuides = this.daysPlanner.finishPage.guides.map( id => {
            return this.daysPlanner.guides[id];
        });

        slides.push({
            tabTitle: 'intro',
            type: 'guide',
            content: introGuides
        });

        this.daysPlanner.days.forEach((day, index) => {
            const dayMenu = day.menu.map( recipeId => this.daysPlanner.recipes.find( recipeSrc => recipeSrc._id === recipeId));
            slides.push({
                type: 'menu',
                content: dayMenu,
                dayIndex: index + 1
            });
        });

        slides.push({
            tabTitle: 'finish',
            type: 'guide',
            content: endingGuides,
            footerButtons: this.daysPlanner.finishPage.footerButtons
        });
        return slides;
    }

    @action
    loadDaysPlanner(daysPlannerId: string) {
        this.daysPlannerService.getDayPlanner(daysPlannerId).pipe(
            tap( res => {
                console.log(res);
                this.guidesStore.setGuides(res.guides);
                this.shoppingListStore.setShoppingListGruops(res.shoppingList, true);
            })
        ).subscribe( res => {
            this.daysPlanner = res;
        });
    }

    @action
    setCurrentDay(doneDayIndex: number) {
        console.log('Done day index:', doneDayIndex);
        this.storage.set('dayIndex', doneDayIndex );
        this.currentDayIndex = doneDayIndex + 1;
    }

    @action
    resetDaysPlane() {
        this.setCurrentDay(0);
        this.shoppingListStore.resetListsItemsSelections();
    }
}
